<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12">
        <p class="primary--text form__title mb-5">MÓDULO: {{ modulo.nome }}</p>
      </v-col>
      <v-col cols="12">
        <BaseDataTable
          :headers="tableHeaders"
          :items="actions"
          show-select
          disable-pagination
          hide-default-footer
          item-key="id"
          v-model="selectedActions"
          class="actions-table base__datatable"
        >
        </BaseDataTable>
      </v-col>
    </v-row>
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="3" class="mr-sm-5 pb-5 pb-sm-0">
          <BaseButton
            v-html="'CANCELAR'"
            class="error font-weight-bold"
            width="100%"
            @click="$emit('close-module')"
          />
        </v-col>
        <v-col cols="12" sm="3">
          <BaseButton
            v-html="'SALVAR'"
            class="secondary font-weight-bold"
            width="100%"
            @click="saveSelectedActions"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </v-form>
</template>
<script>
import { LoadingRequest } from "@/mixins/LoadingMixin";
import _ from "lodash";

const tableHeaders = [
  { text: "Selecionar todos", value: "nome", sortable: false }
];

export default {
  name: "ModuleActionsForm",
  props: ["modulo"],
  mixins: [LoadingRequest],
  data: () => ({
    tableHeaders,
    actions: [],
    selectedActions: []
  }),
  methods: {
    fetchData() {
      this.actions = _.cloneDeep(this.modulo.acoes);
      this.selectedActions.push(
        ...this.actions.filter(action => action.selecionado)
      );
    },
    saveSelectedActions() {
      this.actions.forEach(action => {
        action.selecionado = this.selectedActions.includes(action);
      });
      this.$emit("save-module", this.actions);
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>

<style lang="sass">
.actions-table
  &.v-data-table.theme--light
    thead tr th
      padding: 8px 8px
    tbody tr td
      padding: 18px 8px
  .theme--light.v-icon
    &.mdi-checkbox-marked
      color: var(--v-secondary-base)
</style>
